// extracted by mini-css-extract-plugin
export default {"changeValue":"bl_gW","positive":"bl_gX","negative":"bl_gY"};